module.exports = __webpack_public_path__ + "media/placeholder-images/placeholder_10-08564bec.jpg";